import { useQuery } from '@tanstack/react-query';
import { env } from '../utils/envs';
import QueryKey from '../utils/queryKeys';

async function fetchAnalyticsEventNames(): Promise<string[]> {
  const response = await fetch(
    `${env.VITE_SHINKAI_WEB_API_URL}/api/analytics/event-names`,
  );
  if (!response.ok) {
    throw new Error('Failed to fetch analytics event names');
  }
  const data = await response.json();
  return data.events ?? [];
}

export const useAnalyticsEventNames = () => {
  return useQuery({
    queryKey: [QueryKey.ANALYTICS_EVENT_NAMES],
    queryFn: fetchAnalyticsEventNames,
    staleTime: 60 * 1000, // Cache for 1 minute
  });
};
